module.exports = __webpack_public_path__ + "media/mem_chiar_m.7ee66f39.mp4";